import axios from 'axios';
import { MarketId } from 'types/market-id.enum';
import { DefaultMarketProfile } from 'views/profiles-strategies/features/market-profiles/types/default-market-profile.type';

// GET
// /ewosapi/v2/planandprognosis/default-profile/market/{marketId}
export const getDefaultMarketProfile = async (marketId: MarketId): Promise<DefaultMarketProfile> => {
  const res = await axios.get<DefaultMarketProfile>(`/ewosapi/v2/planandprognosis/default-profile/market/${marketId}`);
  return res.data;
};
